import { Trans } from '@lingui/react'
import classnames from 'clsx'
import { bool, number, shape, string } from 'prop-types'

import { TENANT_CH } from 'shared/consts'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { PriceType, publicRuntimeConfigType } from 'views/utils/propTypes'
import { pickRequired } from 'views/utils/propTypeUtils'

import { currencyToSymbol, formatPriceString } from './helpers'

const Price = props => {
  const {
    currency,
    amount,
    decimalPlaces,
    symbolRight,
    flat,
    dataQa,
    isMasterPage,
    publicRuntimeConfig: {
      publicConfig: { locale, tenant, currencySymbolRight },
    },
  } = props

  // If there is no proper amount passed through nothing will executed
  if (!amount && amount !== 0) {
    return null
  }

  const currencySymbol = currencyToSymbol(currency)
  const price = formatPriceString({
    amount,
    locale,
    decimalPlaces,
    currencySymbol,
    symbolRight: symbolRight || currencySymbolRight,
  })

  return flat ? (
    <>{price}</>
  ) : (
    <span
      className={classnames('u-no-wrap a-Price', {
        'a-Price--small': tenant === TENANT_CH,
      })}
      data-qa-id={dataQa}
    >
      {isMasterPage && price && (
        <>
          <Trans id="general.label.price.from" />{' '}
        </>
      )}
      {price}
    </span>
  )
}

Price.propTypes = {
  ...pickRequired(PriceType, ['currency']),
  amount: number,
  symbolRight: bool,
  decimalPlaces: number,
  flat: bool,
  dataQa: string,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  isMasterPage: bool,
}

Price.defaultProps = {
  amount: 0,
  currency: 'EUR',
  symbolRight: false,
  decimalPlaces: 2,
  flat: false,
  dataQa: undefined,
  isMasterPage: false,
}

export default withShopAndRuntimeConfig(Price)
